<template>
  <div class="sticky-table">
    <table v-if="loading || (data !== null && header)">
      <thead>
        <slot v-if="!!header" name="header" :item="header" />
        <tr v-else>
          <th />
        </tr>
      </thead>
      <div v-if="Array.isArray(data) && !data.length" class="nodata" :class="[loading, 'loading']">
        <slot name="nodata">{{ nodata }}</slot>
      </div>
      <tbody v-else>
        <slot name="body" :items="data" :annotations="annotations">
          <template v-for="(item, index) in data || []">
            <slot name="row" :item="item" :index="index" :annotation="annotations[index] || undefined" />
          </template>
        </slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export { default as Cell } from './Cell'

export default {
  name: 'StickyTable',
  props: {
    /** ヘッダー値 */
    header: { type: [Array, Object], default: () => [] },
    /**
     * ボディー値
     * undefinedの場合tbody内のslotを表示する
     * nullの場合テーブル自体のレンダリングを行わない
     * 0件配列の場合データ無しを表示
     * */
    data: { type: Array, default: undefined },
    /** ボディー値と対になる追加情報 */
    annotations: { type: Array, default: () => [] },
    /** ローディング中フラグ */
    loading: Boolean,
    /** データがない場合に表示する文言 */
    nodata: { type: String, default: '該当するデータはありません' },
  },
}
</script>

<style lang="postcss" scoped>
/* TODO: デザイン仮 */

/** Component固有のcss */
.sticky-table {
  background-color: var(--very-light-gray-4);
  height: 100%;
  overflow: auto;

  /** ハードウェアアクセラレーションの有効化によりiPadのSafariでの画面外表示項目のレンダリングを予め行わせる */
  -webkit-transform: translate3d(0, 0, 0);
  width: 100%;
}

table {
  border-collapse: separate;
  box-sizing: border-box;
  font-size: 13px;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

thead {
  color: var(--white);
  font-weight: 600;
}

tbody {
  color: var(--text-color);
}

th,
td {
  border-bottom: 1px solid var(--border-color);
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  white-space: nowrap;

  &:not(:last-child)::after {
    background-repeat: repeat-y;
    background-size: 1px 5px;
    bottom: 1px;
    content: '';
    position: absolute;
    right: 0;
    top: 1px;
    width: 1px;
  }
}

th {
  background-color: var(--very-dark-gray);
  height: 32px;
  line-height: 1;
  text-align: center;

  &:not(:last-child)::after {
    background-image: linear-gradient(
      to bottom,
      var(--white),
      var(--white) 1px,
      var(--very-dark-gray) 1px,
      var(--very-dark-gray) 4px
    );
  }
}

td {
  background-color: var(--white);
  font-size: 12px;
  height: 56px;
  min-width: 120px;
  padding: 0 8px;

  &:not(:last-child)::after {
    background-image: linear-gradient(
      to bottom,
      var(--dark-gray),
      var(--dark-gray) 1px,
      transparent 1px,
      transparent 4px
    );
  }
}

tr:last-child td {
  border-bottom: none;
}

.nodata {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 300px;

  &.loading {
    background-color: var(--white);
    color: transparent;
  }
}
</style>
